/* globals FichaDesktopDTO, FavoriteRateCommentDTO, FavoritosDTO, __tcfapi */
require('../Common/Trackings/trackings');
require('../Common/Trackings/adwords');
require('../Common/Trackings/BingUET');
require('../Common/Trackings/criteo');
require('../Common/Trackings/facebook');
require('jquery.fleximages');
require('tooltipster');
require('./modules/alert');
require('./modules/modal-avisame');
require('../Global/uj-inject-card');
require('../Global/lead-counter');
require('slick');

var jquery = require('jquery');
var solicitud = require('../Mobile/Solicitudes/SolicitudIndex');
var HabEvents = require('../Global/habitaclia-events');
var UIKeyCodes = require('../Global/keycodes');
var Functions = require('./modules/functions');
var descartarInmueble = require('../Mobile/DescartarInmueble/DescartarInmueble');
var favoritos = require('../Common/Favoritos/Favoritos');
var HabUtils = require('../Global/habitaclia-utils');
var MapaGoogle = require('../Mobile/Ficha/MapaGoogle');
var cookieService = require('../Global/cookie-service');
var AccountUser = require('./modules/account-user.js');
var ModalZona = require('./modules/modal-zona');
var ModalLegal = require('./modules/modal-legal');
var liveNotifications = require('../Global/live-notifications');
var FavoritosRepository = require('../Common/Favoritos/repository/favoritos-repository').default;
var FavoritosService = require('../Common/Favoritos/services/favoritos-service').default;
var FavoritosRateCommentDesktopUI = require('../Common/Favoritos/ui/favoritos-rate-comment-desktop-ui').default;
var FiltrosDesktop = require('./modules/filter-desktop').default;
var storageService = require('../Global/storage-service').default;

import Html5VideoControls from '../Global/html5-video-controls';
import WideMedia from './modules/wide-media.js';
import ListGallery from '../Global/list-gallery';


(function () {
    'use strict';

    var FichaDesktopIndex = function (fichaDesktopDTO, WideMediaDTO, WideMediaPromoDTO, LiveNotificationDTO, MortgageLeadDTO) {
        this.__fichaDesktopDTO = fichaDesktopDTO;
        this.__wideMediaDTO = WideMediaDTO;
        this.__wideMediaPromoDTO = WideMediaPromoDTO;
        this.__liveNotificationDTO = LiveNotificationDTO;
        this.__mortgageLeadDTO = MortgageLeadDTO;
        this.listGallery;
        this._jquerycontenidoFicha = jquery('html');
        this._jquerydestacado = jquery('#js-detail-description-title');
        this._jqueryobservaciones = jquery('#js-detail-description');
        this._jquerytxtTraducido = jquery('#js-txt-translate');
        this._jquerylnkTraducir = jquery('#js-lnk-translate');
        this._jqueryTxtNoTranslate = jquery('#js-txt-no-translate');
        this._jqueryheader = jquery('header');
        this._jquerybackToTop = jquery('#js-back-top');
        this._jquerycontactarSuperior = jquery('#js-contact-top');
        this._jquerycontactarSuperior2;
        this._jqueryminiListado = jquery('#minilistado');
        this._jqueryformularioSolicitud = jquery('#solicitud');
        this._jqueryminiFicha = jquery('#minificha');
        this._jquerynavegacionFichasContenido = jquery('#navegacionfichas a.siguiente, #navegacionfichas a.anterior, #navegacionfichas a.volver');
        this._jqueryvolver = jquery('.navegacionfichas .volver');
        this._jquerysiguiente = jquery('.navegacionfichas .siguiente');
        this._jqueryanterior = jquery('.navegacionfichas .anterior');
        this._jqueryformcontacto = jquery('#js-contact');
        this.__$headMain = jquery('#js-header');
        this.__$headSecond = jquery('#js-head-second');
        this.__$headSecondContent = jquery('#js-head-second-content');
        this.__$rateFav = jquery('#js-rate-fav');
        this.__$commentContainer = jquery('#js-comment-container');
        this.__$editCommentContainer = jquery('#js-edit-comment-container');
        this.__$editCommentText = jquery('#js-edit-comment-text');
        this.__$addComment = jquery('#js-add-comment');
        this.__$comment = jquery('#js-comment');
        this.__$addCommentContainer = jquery('#js-add-comment-container');
        this.__$summaryComment = jquery('#js-summary-comment');
        this.__$rateComment = jquery('#js-rate-comment');
        this.__$rateSaved = jquery('#js-rate-saved');
        this.__$noCommentMessage = jquery('#js-no-comment-message');
        this.__$commentSaved = jquery('#js-commment-saved');
        this.__$cover = jquery('#js-cover');
        this.__$coverImage = jquery('#js-cover-image');
        this.__$coverLess = jquery('#js-cover-less');
        this.__$gallery = jquery('#js-gallery');
        this.__$promoGallery = jquery('#js-promo-gallery');
        this.__$flexImages = jquery('.flex-images');
        this.__$promoFlexImages = jquery('.flex-images-promo');
        this.__$imageItem = jquery('.flex-image');
        this.__$promoImageItem = jquery('.flex-images-promo .flex-image');
        this.__$btnShareFacebook = jquery('#js-btn-share-facebook');
        this.__$btnShareTwitter = jquery('#js-btn-share-twitter');
        this.__$btnShareEnviarAmigo = jquery('#js-btn-share-enviaramigo');
        this.__$btnVerMapaZona = jquery('#js-ver-mapa-zona');
        this.__$btnImprimir = jquery('#js-btn-imprimir');
        this.__$counterofferTxt = jquery('#js-counteroffer-offer');
        this.__$focusSolicitud = jquery('#formularioSolicitudDiv');
        this.__$reportErrorBottom = jquery('#js-report-bottom');
        this.__$navFixed = jquery('#js-nav-fixed');
        this.__$navBottomBack = jquery('#nav-back');
        this.__$navDetail = jquery('.nav-detail');
        this.__$navKeyboard = jquery('#js-nav-keyboard');
        this.__destacadoTraducido = null;
        this.__observacionesTraducidas = null;
        this.__$mensajeSolicitud = jquery('#Mensaje');
        this.__scrolled = false;
        this.__lastScrollTop = 0;
        this.__minScroll = 56;
        this.__posicionIniFicha = 500;
        this.__posicionIniBgOrange = 250;
        this.__positionGallery = 1800;
        this.__iLengthFormularioContacto = this._jqueryformcontacto.length;
        this.__wideMedia;
        this.__liveNotifications;
        this.__inmueblesVisitados = [];
        this._COOKIENAME = 'InmueblesVisitados';
        this.html5VideoControls = new Html5VideoControls();
        if (this._jquerycontactarSuperior.length > 0) {
            this.__posicionIniFicha = this._jquerycontactarSuperior.offset().top;
            this.__posicionIniBgOrange = this.__posicionIniFicha / 4;
            this.__posicionValue = 100 / ((this.__posicionIniFicha / 1.5) - (this.__posicionIniBgOrange));
        }
        if (this.__$gallery.length > 0) {
            this.__positionGallery = this.__$gallery.offset().top;
        }
        if (this.__iLengthFormularioContacto > 0) {
            this.__$formcontactoPosition = this._jqueryformcontacto.offset().top;
            this.__$formcontactoPositionMax = this.__$formcontactoPosition + 700;
        }
        this.__delayInterval;
        this.__delayInterval1;
        this.__scrolloncontactar = false;
        this.__scrolleddatos = false;
        this.__scrolledMiniListado = false;
        this.__bHayFormularioSolicitud = this._jqueryformularioSolicitud.length > 0;
        this.__iOffsetFormularioSolicitud = (this.__bHayFormularioSolicitud > 0 ? this._jqueryformcontacto.height() / 2 : 0);
        this.__iDistanciaTopFormularioSolicitud = __getTopFormularioSolicitud.call(this);
        this.__bHayMiniListadoFicha = this._jqueryminiListado.length > 0;
        this.__formContactoHeight = this._jqueryformcontacto.height();
        this.__similarControl = false;
        this.__mapaGoogle = new MapaGoogle(fichaDesktopDTO.GMapsConfig);
        this.__$reportErrorBtn = jquery('#js-report');
        this.__$reportErrorBtn2 = jquery('#js-report-2');
        this.__$reportErrorContainer = jquery('#js-report-container');
        this.__$reportErrorChild = jquery('#js-report-container > form');
        this.__$reportErrorForm = jquery('#js-report-form');
        this.__$reportErrorList = jquery("#js-report-list");
        this.__$calcHipoteca = jquery('.js-calc-hipoteca');
        this.__$calcHipotecaTop = jquery('.js-calc-hipoteca-top');
        this.__$calcHipotecaBottom = jquery('.js-calc-hipoteca-bottom');
        this.__$filterBtn = jquery('#js-filter-submit');

        __tcfapi && __tcfapi('getTCData',2, data => {
            if (data.purpose.consents[5] && data.purpose.consents[6] && data.purpose.consents[10]){
                __visitadosCookieManager.call(this);
            }
        });

        __cloneContactTop.call(this);
        __registerEvents.call(this);

        const favoritosRepository = new FavoritosRepository(FavoritosDTO);
        const favoritosService = new FavoritosService(favoritosRepository, FavoritosDTO);
        this.favoritosRateCommentDesktopUI = new FavoritosRateCommentDesktopUI(FavoriteRateCommentDTO, favoritosService);

        this.__storageService = new storageService(window.sessionStorage);

        if(document.getElementById('js-filters')){
            this.filtrosDesktop = new FiltrosDesktop(this.__fichaDesktopDTO.filterDesktopDTO);
            __alertInDetail.call(this);
        }

        this.html5VideoControls.bindAllVideos();

        if (this.__$gallery.length > 0) {
            __registerGallery.call(this);
        }
        if (this.__$promoGallery.length > 0) {
            __registerPromoGallery.call(this);
        }
        __launchFichaLoaded();
        __setDescartado.call(this);

        if (window.location.href.indexOf('addFav=1') > 0) {
            var codigoAnuncio;

            if (window.location.href.indexOf('codigo=') > 0) {
                codigoAnuncio = HabUtils.GetURLParameterFromGivenURL('codigo', window.location.href);
            }

            favoritos.ManageFavs(undefined, this.favoriteRateComment, this.favoriteRateComment.callbackAddRemoveFav, codigoAnuncio, this.__fichaDesktopDTO.realEstateAdId);
        }

        if (this.__fichaDesktopDTO.isMapaVisible && this.__fichaDesktopDTO.GMapsConfig && this.__fichaDesktopDTO.GMapsConfig.initialize) {
            this.__mapaGoogle.InitializeMap();
        }
        __unbranded.call(this);
        __addInmuebleVisitado.call(this);
        jquery.publish(HabEvents.EventsEnum.ModuloLiderNoCargado);
    };

    var __registerEvents = function () {
        var self = this;

        ModalLegal.RegisterEvents();

        jquery.subscribe(HabEvents.EventsEnum.LoginAjaxOk, () => {
            if (this.__storageService.itemExist("user")) {
                var user = this.__storageService.getItem("user");
                this.__fichaDesktopDTO.idUsuario = user.id;
            }
        });

        this.__$headSecondContent.html(jquery('#js-feature-container').html());

        if (this.__fichaDesktopDTO.precioProducto !== '0' && this.__fichaDesktopDTO.precioProducto !== '0,00') {
            this.__$headSecondContent.find('.feature-container').prepend('<li class="feature"><strong>' + this.__fichaDesktopDTO.priceFormated + '</strong></li>');
        } else {
            this.__$headSecondContent.find('.feature-container').prepend('<li class="feature">' + this.__fichaDesktopDTO.Translate.ConsultPrice + '</li>');
        }

        var $detailDescription = jquery('.detail-description');
        var $detailDescriptionOpenButton = jquery('#js-detail-mask');
        if ($detailDescription.height() >= 650) {
            $detailDescriptionOpenButton.addClass('detail-demask-active');
            $detailDescription.addClass('detail-mask');
        }
        $detailDescriptionOpenButton.on('click', function () {
            $detailDescription.removeClass('detail-mask');
            $detailDescriptionOpenButton.removeClass('detail-demask-active');
        });

        jquery('#solicitudesForm').submit(function (event) {
            event.preventDefault();
            jquery('#respuestaSolicitud').hide();
            solicitud.Validar_Y_Enviar_Solicitud();
        });

        jquery('#mapa').click(function () {
            self.__mapaGoogle.InitializeMap();
        });
        this.__$focusSolicitud.focusin(function () {
            __focusInSolicitud.call(self);
        });
        this.__$focusSolicitud.focusout(function () {
            __focusOutSolicitud.call(self);
        });
        jquery('#js-btn-mapa').click(function () {
            jquery('#js-btn-streetview').removeClass('selected');
            jquery(this).addClass('selected');
            jquery('#streetview').addClass('hide-none');
            jquery('#mapa').removeClass('hide-none');
        });

        jquery('#js-btn-streetview').click(function () {
            jquery('#streetview').removeClass('hide-none');
            jquery('#js-btn-mapa').removeClass('selected');
            jquery(this).addClass('selected');
            jquery('#mapa').addClass('hide-none');
            self.__mapaGoogle.InitializeStreetView();
        });

        jquery('.js-ver-telefono-btn').click(
            function (event) {
                event.preventDefault();
                solicitud.VerTelefono();
            }
        );

        jquery('.js-print').click(function () {
            window.print();
        });

        this.__$btnShareEnviarAmigo.click(function () {
            jquery.publish(HabEvents.EventsEnum.ClickCompartirFicha, self.__fichaDesktopDTO.tipReg + self.__fichaDesktopDTO.codigoAnuncio);
        });

        this.__$btnShareTwitter.click(function () {
            jquery.publish(HabEvents.EventsEnum.ClickCompartirFicha, self.__fichaDesktopDTO.tipReg + self.__fichaDesktopDTO.codigoAnuncio);
        });

        this.__$btnShareFacebook.click(function () {
            jquery.publish(HabEvents.EventsEnum.ClickCompartirFicha, self.__fichaDesktopDTO.tipReg + self.__fichaDesktopDTO.codigoAnuncio);
        });

        this.__$coverImage.click(
            function (event) {
                event.preventDefault();
                event.stopPropagation();
                jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-cover', 'ampliar-foto']);
                jquery.publish(HabEvents.EventsEnum.CoverClick);
                jquery('body').addClass('wide-media-cover');
                jquery('#js-cover').removeClass('u-bg-orange');
                jquery('#js-wide-content').addClass('first-from-cover');
                if (jquery(this).hasClass('js-cover-3d')) {
                    setTimeout(function () { self.__wideMedia = new WideMedia(self.__wideMediaDTO, 'vid3D', 0, jquery(this).attr('url')); }, 650);
                } else if (jquery(this).hasClass('js-cover-360')) {
                    setTimeout(function () { self.__wideMedia = new WideMedia(self.__wideMediaDTO, 'vid360', 0, jquery(this).attr('url')); }, 650);
                } else {
                    setTimeout(function () { self.__wideMedia = new WideMedia(self.__wideMediaDTO, 'img', 0, jquery(this).attr('url')); }, 650);
                }
            }
        );

        jquery('.flex-image').click(
            function (event) {
                event.preventDefault();
                event.stopPropagation();
                var $this = jquery(this);
                if ($this.parent().hasClass('flex-images-promo')) {
                    self.__wideMedia = new WideMedia(self.__wideMediaPromoDTO, $this.attr('data-wide-type'), parseInt($this.attr('data-wide-order'), $this.attr('url')));
                } else {
                    self.__wideMedia = new WideMedia(self.__wideMediaDTO, $this.attr('data-wide-type'), parseInt($this.attr('data-wide-order'), $this.attr('url')));
                }
            }
        );

        jquery('body').on('keyup', function (e) {
            if (e.target.nodeName !== 'TEXTAREA' && e.target.nodeName !== 'INPUT' && jquery('.wide-media-open').length === 0) {
                if (e.which === UIKeyCodes.UIKeyCodesEnum.RIGHT && jquery('#js-nav-fixed-next').length > 0) {
                    jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-key', 'siguiente']);
                    document.location.href = jquery('#js-nav-fixed-next').attr('href');
                }
                if (e.which === UIKeyCodes.UIKeyCodesEnum.LEFT && jquery('#js-nav-fixed-prev').length > 0) {
                    jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-key', 'anterior']);
                    document.location.href = jquery('#js-nav-fixed-prev').attr('href');
                }
            }
        });
        jquery('#js-map-more-btn').click(function () {
            jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-link', 'mas_anuncios_zona']);
        });
        jquery('#js-nav-fixed-next').click(function () {
            jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-button', 'siguiente']);
        });
        jquery('#js-nav-fixed-prev').click(function () {
            jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-button', 'anterior']);
        });
        jquery('#js-nav-detail-next').click(function () {
            jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-link', 'siguiente']);
        });
        jquery('#js-nav-detail-prev').click(function () {
            jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-link', 'anterior']);
        });
        jquery('#js-head-back').click(function (e) {
            e.preventDefault();
            if (window.location.href.indexOf("forceback") > 0) {
                window.history.back();
            } else {
                window.document.location.href = this.href;
            }
            jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-button', 'listado']);
        });
        jquery('#nav-back').click(function () {
            jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-link', 'listado']);
        });
        jquery('#js-similar-top li').click(function () {
            jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-link', 'anunciosinteresantes']);
            jquery.publish(HabEvents.GTMEcommerceEventsEnum.ClicGtmItemUrl, jquery(this).data());
        });
        jquery('#js-similar-bottom li').click(function () {
            jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-link', 'anunciossimilares']);
            jquery.publish(HabEvents.GTMEcommerceEventsEnum.ClicGtmItemUrl, jquery(this).data());
        });
        jquery('#js-map-similar li').click(function () {
            jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-link', 'anuncioszona']);
            jquery.publish(HabEvents.GTMEcommerceEventsEnum.ClicGtmItemUrl, jquery(this).data());
        });
        jquery('#js-more-photo').click(
            function () {
                if (self.__$mensajeSolicitud.length > 0) {
                    self.__$mensajeSolicitud.val(self.__fichaDesktopDTO.Translate.MorePhoto + ' habitaclia/' + self.__fichaDesktopDTO.refEmp);
                }
            }
        );
        jquery('.notify').click(function () {
            jquery.publish(HabEvents.EventsEnum.ClickAvisameSiBajaFicha, ['Informacion', 'ficha', 'avisamesibaja']);
        });

        jquery('#js-btn-mas-anuncios-zona').click(function () {
            jquery.publish(HabEvents.EventsEnum.VerMasAnunciosEnLaZona);
        });

        jquery('#js-lnk-translate').click(function (e) {
            e.preventDefault();

            if (!self.__destacadoTraducido || !self.__observacionesTraducidas) {
                var dataToTranslate = {
                    codigoEmpresa: self.__fichaDesktopDTO.codigoEmpresa,
                    codigoOficina: self.__fichaDesktopDTO.codigoOficina,
                    codigoProducto: self.__fichaDesktopDTO.codigoProducto,
                    esPromo: self.__fichaDesktopDTO.esPromo
                };

                var request = jquery.ajax({
                    type: 'POST',
                    url: self.__fichaDesktopDTO.UrlAjaxTranslate,
                    data: dataToTranslate,
                });

                request.done(function (data) {
                    if (data && data.Status > 0) {
                        __showTraduccion.call(self, data.Destacado, data.Observaciones);
                    } else {
                        __showTraduccionNoAvaible.call(self);
                    }
                });

            } else {
                __showTraduccion.call(self, self.__destacadoTraducido, self.__observacionesTraducidas);
            }
        });

        jquery('.js-calc-hipoteca,.js-calc-hipoteca-top,.js-calc-hipoteca-bottom').click(function (e) {
            e.preventDefault();
            location.href = 'https://pubads.g.doubleclick.net/gampad/clk?id=6387629232&iu=/5180329/ficha_wde_services_1';
        });

        jquery('#js-lnk-txt-original').click(function (e) {
            e.preventDefault();
            self._jquerydestacado.text(self.__fichaDesktopDTO.destacado);
            self._jqueryobservaciones.text(self.__fichaDesktopDTO.observaciones);
            self._jquerytxtTraducido.hide();
            self._jquerylnkTraducir.show();
        });

        jquery('#js-menu-anchor a').click(function (e) {
            e.preventDefault();
            Functions.ScrollTo(jquery(e.currentTarget).attr('href'), -100, 500);
        });

        jquery('#js-back-top').on('click', function (e) {
            e.preventDefault();
            Functions.ScrollTo('#js-cover-image', 0, 500);
        });

        jquery('#js-sim-vertical-01, #js-sim-vertical-02, #js-sim-vertical-03').unbind().click(function () {
            var jqThis = jquery(this);
            jqThis.siblings().removeClass('sim-button-active');
            jquery('.sim-container-vertical>.sim-full').removeClass('sim-full-pos1').removeClass('sim-full-pos2').removeClass('sim-full-pos3').addClass('sim-full-pos' + jqThis.attr('data-id'));
            jqThis.addClass('sim-button-active');
        });
        jquery('#js-sim-horizontal-01, #js-sim-horizontal-02, #js-sim-horizontal-03').unbind().click(function () {
            var jqThis = jquery(this);
            jqThis.siblings().removeClass('sim-button-active');
            jquery('.sim-container-horizontal>.sim-full').animate({
                opacity: 0.25
            }, 200, function () {
                jquery('.sim-container-horizontal>.sim-full').removeClass('sim-full-pos1').removeClass('sim-full-pos2').removeClass('sim-full-pos3').addClass('sim-full-pos' + jqThis.attr('data-id')).animate({ opacity: 1 }, 200);
            });
            jqThis.addClass('sim-button-active');
        });

        jquery('.share-friend').click(function () {
            Functions.CreateWindow(jquery(this).attr('data-window'), 740, 500);
        });

        jquery(window).resize(function () {
            if (self.__posicionIniFicha.length > 0) {
                self.__posicionIniFicha = self._jquerycontactarSuperior.offset().top;
                self.__posicionIniBgOrange = self.__posicionIniFicha / 4;
                self.__posicionValue = 100 / ((self.__posicionIniFicha / 1.5) - (self.__posicionIniBgOrange));
            }
            if (self.__iLengthFormularioContacto > 0) {
                self.__$formcontactoPosition = self._jqueryformcontacto.offset().top;
                self.__$formcontactoPositionMax = self.__$formcontactoPosition + 700;
            }
        });

        jquery(window).scroll(function () {
            self.__$cover.addClass('u-bg-orange');
            self.__scrolled = true;
            var scrollTop = jquery(window).scrollTop();

            if (scrollTop > self.__posicionIniBgOrange) {
                var percent = 1 - ((scrollTop - self.__posicionIniBgOrange) * self.__posicionValue) / 100;
                __updateBgColorCover.call(self, percent);
            } else {
                __updateBgColorCover.call(self, 1);
            }

            if (scrollTop >= (jquery('#js-similar-top').scrollTop() + 200)) {
                if (!self.__similarControl) {
                    self.__similarControl = true;
                    jquery('#js-sim-vertical-01').trigger('click');
                }
            }

            if (scrollTop > 90) {
                self._jqueryheader.addClass('scrolled');
            }

            if (scrollTop < (self.__posicionIniFicha - 45)) {
                self.__$headSecond.removeClass('head-second-visible');
                self._jquerycontactarSuperior2.addClass('hide-none');
                self._jquerycontactarSuperior2.removeClass('contact-top-down');
                self._jquerybackToTop.removeClass('back-top-visible');
            } else {
                if (self.__scrolled) {
                    __hasScrolled.call(self, scrollTop);
                    self.__scrolled = false;
                }
            }
            if (scrollTop > self.__posicionIniFicha - 200 && scrollTop < self.__posicionIniFicha + 200) {
                self._jqueryheader.addClass('head-main-hide');
            } else if (scrollTop <= self.__posicionIniFicha - 200) {
                self._jqueryheader.removeClass('head-main-hide');
                self._jqueryheader.removeClass('bg-orange');
                self.__$headMain.removeClass('bg-orange');
            } else if (scrollTop >= self.__posicionIniFicha + 200) {
                self.__$headMain.addClass('bg-orange');
            }
            if (self.__posicionIniFicha - 200 <= scrollTop) {
                self._jquerycontactarSuperior2.css('transition-delay', '0s');
                clearInterval(self.__delayInterval);
                clearInterval(self.__delayInterval);
            }
            if (self.__posicionIniFicha - 200 <= scrollTop && !self.__scrolloncontactar) {
                self._jquerycontactarSuperior2.removeClass('contact-top-fixed-up');
                self.__scrolloncontactar = true;
            }
            if (self.__posicionIniFicha - 200 > scrollTop && self.__scrolloncontactar) {
                self._jquerycontactarSuperior2.addClass('contact-top-fixed-up');
                self.__scrolloncontactar = false;
            }
            if (self.__posicionIniFicha - 57 <= scrollTop && !self.__scrolleddatos) {
                self._jquerycontactarSuperior2.addClass('contact-top-fixed');
                self.__scrolleddatos = true;
            }
            if (self.__posicionIniFicha - 57 > scrollTop && self.__scrolleddatos) {
                self._jquerycontactarSuperior2.removeClass('contact-top-fixed');
                self.__scrolleddatos = false;
            }
            if (self.__positionGallery - 30 <= scrollTop) {
                self._jquerycontactarSuperior2.addClass('contact-top-fixed-bar');
            }
            if (self.__positionGallery - 30 > scrollTop) {
                self._jquerycontactarSuperior2.removeClass('contact-top-fixed-bar');
            }

            if (self.__iLengthFormularioContacto > 0) {

                if (self.__posicionIniFicha - 30 < scrollTop && !self.__scrolled) {
                    self.__$headSecond.addClass('head-second-visible');
                    //self._jqueryheader.addClass('head-main-hide');
                    self._jquerycontactarSuperior2.removeClass('hide-none');
                    self._jqueryvolver.addClass('item-fijo');
                    self._jquerysiguiente.addClass('item-fijo');
                    self._jqueryanterior.addClass('item-fijo');

                    self._jquerynavegacionFichasContenido.animate(300, function () {
                        self._jqueryminiFicha.fadeIn(0);
                    });
                    self.__scrolled = true;
                }
                if (self.__posicionIniFicha - 150 >= scrollTop && !self.__scrolled) {
                    self._jqueryheader.removeClass('head-main-hide');
                }
                if (self.__posicionIniFicha - 30 >= scrollTop && self.__scrolled) {
                    self._jqueryminiFicha.hide().removeAttr('style');
                    self.__$headSecond.removeClass('head-second-visible');
                    self._jquerycontactarSuperior2.addClass('hide-none');
                    self._jquerynavegacionFichasContenido.removeAttr('style');
                    self._jqueryvolver.removeClass('item-fijo');
                    self._jquerysiguiente.removeClass('item-fijo');
                    self._jqueryanterior.removeClass('item-fijo');
                    self.__scrolled = false;
                }
                if (scrollTop > self.__$formcontactoPosition && scrollTop < self.__$formcontactoPositionMax) {
                    self._jquerycontactarSuperior2.addClass('u-hide-none');
                } else {
                    self._jquerycontactarSuperior2.removeClass('u-hide-none');
                    __focusOutSolicitud.call(self);
                }
            }

            if (self._jqueryminiListado) {
                if (self.__iDistanciaTopFormularioSolicitud + self.__iOffsetFormularioSolicitud <= scrollTop && !self.__scrolledMiniListado) {
                    self._jqueryminiListado.addClass('open');
                    self.__scrolledMiniListado = true;
                }
                if (self.__iDistanciaTopFormularioSolicitud + self.__iOffsetFormularioSolicitud > scrollTop && self.__scrolledMiniListado) {
                    self._jqueryminiListado.removeClass('open');
                    self.__scrolledMiniListado = false;
                }
            }
        });
        this.__$reportErrorBtn2.click(function () {
            self.__$reportErrorContainer.removeClass('u-expanded');
            jquery(this).parent().append(self.__$reportErrorContainer);
            __registerReportError.call(self);
            Functions.ExpandElement(self.__$reportErrorContainer, self.__$reportErrorChild);
        });
        this.__$reportErrorBtn.click(function () {
            self.__$reportErrorContainer.removeClass('u-expanded');
            jquery(this).parent().append(self.__$reportErrorContainer);
            __registerReportError.call(self);
            Functions.ExpandElement(self.__$reportErrorContainer, self.__$reportErrorChild);
        });


        this.__$counterofferTxt.focus(function () {
            self.__$counterofferTxt.val('');
        });

        this.__$counterofferTxt.blur(function () {
            if (!self.__$counterofferTxt.val()) {
                self.__$counterofferTxt.val(self.__fichaDesktopDTO.priceFormated);
            }
        });

        jquery('.counteroffer-btn').click(function (e) {
            e.preventDefault();
            __counterofferCheck.call(self);
        });

        jquery('.js-contact-telephone-btn, #js-contact-top-phone-container-2 a').click(function () {
            if (self.__fichaDesktopDTO.Geo.isCVMRegion === 'True') {
                var sDataReferencia = jquery('#descripcion').data('referencia');
                sDataReferencia = (sDataReferencia !== undefined ? sDataReferencia : '');
                jquery('#etiquetadescripcion, #descripcion, #idLabelRecordarDatos, #Mensaje').css({
                    'display': 'none', 'visibility': 'hidden'
                });
                jquery('#etiquetaemail .tiny-span').remove();
            }
            jquery('#js-contact-alert-telephone').removeClass('hide-none');

            jquery.publish(HabEvents.EventsEnum.ClickVerTelefonoFicha);
        });

        jquery('#js-more-photo').click(
            function () {
                if (self.__$mensajeSolicitud.length > 0) {
                    self.__$mensajeSolicitud.val(self.__fichaDesktopDTO.Translate.MorePhoto + ' habitaclia/' + self.__fichaDesktopDTO.refEmp);
                }
            }
        );

        jquery('#js-cont-superior').click(function () {
            jquery.publish(HabEvents.EventsEnum.ClickContactarFicha, ['contactarficha']);
        });
        jquery('#js-cont-superior-2').click(function () {
            jquery.publish(HabEvents.EventsEnum.ClickContactarFicha, ['contactarfichaflotante']);
        });

        this.__$calcHipoteca.on('click touchstart', function () {
            jquery.publish(HabEvents.EventsEnum.ClickCalcHipoteca, ['detail']);
        });
        this.__$calcHipotecaTop.on('click touchstart', function () {
            jquery.publish(HabEvents.EventsEnum.ClickCalcHipoteca, ['detailtop']);
        });
        this.__$calcHipotecaBottom.on('click touchstart', function () {
            jquery.publish(HabEvents.EventsEnum.ClickCalcHipoteca, ['detailbottom']);
        });

        this.__$filterBtn.click( function () {
            jquery.publish(HabEvents.EventsEnum.ClickFiltroFicha);
         });

        jquery('.jq-tooltip').tooltipster({ contentCloning: true });
        jquery('.jq-tooltip-white').tooltipster({
            contentCloning: true,
            theme: 'hab-white',
            trigger: 'click'
        });

        this.__$btnVerMapaZona.click(function (e) {
            e.preventDefault();
            var modalZona = new ModalZona({
                urlGetMapaZona: self.__fichaDesktopDTO.urlGetMapaZona,
                codProv: self.__fichaDesktopDTO.Geo.codProv,
                codPob: self.__fichaDesktopDTO.Geo.codPob,
                codZona: self.__fichaDesktopDTO.Geo.codZona,
                language: self.__fichaDesktopDTO.language,
                traducciones: {
                    cerrar: self.__fichaDesktopDTO.Translate.Close
                }
            });

            modalZona.ShowModalMapaZona();
        });

        jquery.subscribe(HabEvents.EventsEnum.ConfirmacionSolicitudEnviada, function () {
            this.listGallery = new ListGallery();
        });

        self.__liveNotifications = new liveNotifications(self.__liveNotificationDTO);

        setTimeout(function () {
            self.__liveNotifications.SetLiveFromTemplate('info-alerta', '<img src="' + self.__liveNotificationDTO.helpImage + '"><div class="live-info-container"><span class="live-title">' + self.__liveNotificationDTO.helpText + '</span><button type="button">' + self.__liveNotificationDTO.helpButton + '</button></div>', 'live-item pointer-events-all bg-black-alpha', self.__liveNotificationDTO.helpLink);
        }, 60000);
    };

    var __updateBgColorCover = function (percent) {
        if (percent < 0.8) {
            var percentShadow = percent - 0.2;
            this._jqueryheader.css('background', 'linear-gradient(to bottom,rgba(0,0,0,' + percentShadow + ') 0,transparent 0%)');
        }
        this.__$coverImage.css('opacity', percent);
        this.__$coverLess.css('opacity', percent);
    };

    var __updateContactPosition = function () {
        if (this.__iLengthFormularioContacto > 0) {
            this.__$formcontactoPosition = this._jqueryformcontacto.offset().top - 700;
            this.__$formcontactoPositionMax = this.__$formcontactoPosition + 1400;
        }
    };

    var __cloneContactTop = function () {
        var $div = $("<div>", { "class": "max-1440" });
        var $copyContact = jquery('#js-contact-top').clone(true);
        $copyContact.find('#js-contact-top-phone-container').attr('id', 'js-contact-top-phone-container-2');
        $copyContact.find('#js-cont-superior').attr('id', 'js-cont-superior-2');
        $copyContact.find('#js-contact-top-text').attr('id', 'js-contact-top-text-2');
        $copyContact.attr('id', 'js-contact-top-2');
        $copyContact.addClass('hide-none');
        $div.append($copyContact);
        this.__$headSecond.after($div);
        this._jquerycontactarSuperior2 = jquery('#js-contact-top-2');

        jquery('#js-contact-top-text-2').bind('keypress keyup blur', function () {
            jquery('#js-contact-top-text').val(jquery(this).val());
        });
    };

    var __registerReportError = function () {
        var self = this;

        this.__$reportErrorForm.off().on("submit", function (e) {
            e.preventDefault();
            var $Form, $Error;
            $Form = jquery(this);
            $Error = jquery(".error-text");
            jquery.post(self.__fichaDesktopDTO.rutaMenu + "/hab_inmuebles/ajax/registrarerror.asp", $Form.serialize(), function (data) {
                jquery("#js-report-list").removeClass("error");
                jquery("#js-report-cause").removeClass("error");
                if (data.status === 0) {
                    $Error.addClass("hide-none");
                    $Form.remove();
                    self.__$reportErrorContainer.html(data.description);
                    //jquery(".mensajeerrores").after("<a href=\"#\" class=\"boton closeModal\">" + oLangs.translation("idButtonClose") + "<\a>");
                } else {
                    switch (data.status) {
                        case 1:
                            jquery("#js-report-list").addClass("error");
                            break;
                        case 2:
                            break;
                        case 3:
                            jquery("#js-report-cause").addClass("error");
                            break;
                        default:
                    }
                    $Error.removeClass("hide-none").html(data.description);
                }
            }, "json");
        });

        this.__$reportErrorList.off().on('change', function () {
            var $textoMotivo = jquery('label[for="js-report-cause"]');
            jquery(this).removeClass('error');
            if (jquery('#js-report-list option:selected').hasClass('motivo')) {
                $textoMotivo.removeClass('hide-none');
            } else {
                $textoMotivo.addClass("hide-none");
            }
        });
    };


    var __registerGallery = function () {
        var self = this;
        self.__$gallerySizeP = jquery('#js-gallery-size-p');
        self.__$gallerySizeN = jquery('#js-gallery-size-n');
        self.__$gallerySizeG = jquery('#js-gallery-size-g');
        self.__$morePicsBtn = jquery('#js-more-pictures');
        self.__$allPicsBtm = jquery('#js-all-img');

        var c = this.__fichaDesktopDTO.cookieGallery;
        if (this.__fichaDesktopDTO.IsMobileApp !== 'False') {
            c = 'n';
        }
        switch (c) {
            case 'g':
                __toGalleryG.call(this);
                break;
            case 'n':
                __toGalleryN.call(this);
                break;
            default:
                __toGalleryP.call(this);
        }
        self.__$gallerySizeN.click(function () {
            __toGalleryN.call(self);
            jquery.publish(HabEvents.EventsEnum.ClickTamanoGaleria, ['fotos-mediano', 'ver']);
        });
        self.__$allPicsBtm.click(function () {
            __toGalleryN.call(self);
        });
        self.__$gallerySizeP.click(function () {
            __toGalleryP.call(self);
            jquery.publish(HabEvents.EventsEnum.ClickTamanoGaleria, ['fotos-galeria', 'ver']);
        });
        self.__$gallerySizeG.click(function () {
            __toGalleryG.call(self);
            jquery.publish(HabEvents.EventsEnum.ClickTamanoGaleria, ['fotos-grandes', 'ver']);
        });
    };

    var __registerPromoGallery = function () {
        var self = this;
        self.__$promoGallerySizeP = jquery('#js-promo-gallery-size-p');
        self.__$promoGallerySizeN = jquery('#js-promo-gallery-size-n');
        self.__$promoGallerySizeG = jquery('#js-promo-gallery-size-g');
        //self.__$morePicsBtn = jquery('#js-more-pictures');
        //self.__$allPicsBtm = jquery('#js-all-img');

        var c = this.__fichaDesktopDTO.cookieGallery;
        if (this.__fichaDesktopDTO.IsMobileApp !== 'False') {
            c = 'n';
        }
        switch (c) {
            case 'g':
                __toPromoGalleryG.call(this);
                break;
            case 'n':
                __toPromoGalleryN.call(this);
                break;
            default:
                __toPromoGalleryP.call(this);
        }
        self.__$promoGallerySizeN.click(function () {
            __toPromoGalleryN.call(self);
        });
        self.__$promoGallerySizeP.click(function () {
            __toPromoGalleryP.call(self);
        });
        self.__$promoGallerySizeG.click(function () {
            __toPromoGalleryG.call(self);
        });
    };
    var __toPromoGalleryN = function () {
        resetHeightGallery();
        this.__$promoGallerySizeP.removeClass('active');
        this.__$promoGallerySizeG.removeClass('active');
        this.__$promoGallerySizeN.addClass('active');
        this.__$promoFlexImages.addClass('n').removeClass('g').removeClass('p').removeClass('flex-images-g');
        this.__$promoImageItem.addClass('n').removeClass('g').removeClass('p');
        this.__$promoImageItem.removeAttr('style');
        this.__$promoFlexImages.children('img').attr('src', function () {
            var src = jquery(this).attr('src');
            if (src.indexOf('G.jpg') === -1) {
                src = src.replace(/.jpg/i, 'G.jpg');
                jquery(this).parent().attr('style', 'background-image:url(' + src + ')');
            }
            return src;
        });
        this.__$promoFlexImages.flexImages({ rowHeight: 600, truncate: 0, miniatures: false, big: false });
        cookieService.setCookie('ad_tamanofotos', 'n', Infinity);
        __updateContactPosition.call(this);
    };

    var __toPromoGalleryP = function () {
        resetHeightGallery();
        this.__$promoFlexImages.addClass('p').removeClass('n').removeClass('g').removeClass('flex-images-g');
        this.__$promoGallerySizeP.addClass('active');
        this.__$promoGallerySizeN.removeClass('active');
        this.__$promoGallerySizeG.removeClass('active');
        this.__$promoImageItem.removeAttr('style');
        jquery('.fotos-responsive').removeClass('fotos-g').removeClass('fotos-n');
        this.__$promoFlexImages.children('.n').css('height', (jquery('.ficha_foto.n').width() * 600) / 800);
        cookieService.setCookie('ad_tamanofotos', 'p', Infinity);
        this.__$promoFlexImages.flexImages({ rowHeight: 600, truncate: 0, miniatures: true, big: false });
        this.__$promoFlexImages.children('.p').removeAttr('style');
        __updateContactPosition.call(this);
    };

    var __toPromoGalleryG = function () {
        this.__$promoFlexImages.flexImages({ big: true });
        this.__$promoFlexImages.removeClass('p').removeClass('n').addClass('g').addClass('flex-images-g');
        this.__$promoImageItem.addClass('g').removeClass('n').removeClass('p');
        this.__$promoGallerySizeG.addClass('active');
        this.__$promoGallerySizeN.removeClass('active');
        this.__$promoGallerySizeP.removeClass('active');
        this.__$promoImageItem.removeAttr('style');
        this.__$promoFlexImages.children('image').attr('src', function () {
            var src = jquery(this).attr('src');
            if (src.indexOf('G.jpg') === -1) {
                src = src.replace(/P.jpg/i, '.jpg');
                src = src.replace(/.jpg/i, 'G.jpg');
            }
            return src;
        });
        cookieService.setCookie('ad_tamanofotos', 'g', Infinity);
        checkHeightGallery.call(this);
        __updateContactPosition.call(this);
    };

    var __toGalleryN = function () {
        resetHeightGallery();
        this.__$morePicsBtn.addClass('u-hide-none');
        this.__$allPicsBtm.addClass('u-hide-none');
        this.__$gallerySizeP.removeClass('active');
        this.__$gallerySizeG.removeClass('active');
        this.__$gallerySizeN.addClass('active');
        this.__$flexImages.addClass('n').removeClass('g').removeClass('p').removeClass('flex-images-g');
        this.__$imageItem.addClass('n').removeClass('g').removeClass('p');
        this.__$imageItem.removeAttr('style');
        this.__$flexImages.children('img').attr('src', function () {
            var src = jquery(this).attr('src');
            if (src.indexOf('G.jpg') === -1) {
                src = src.replace(/.jpg/i, 'G.jpg');
                jquery(this).parent().attr('style', 'background-image:url(' + src + ')');
            }
            return src;
        });
        this.__$flexImages.flexImages({ rowHeight: 600, truncate: 0, miniatures: false, big: false });
        cookieService.setCookie('ad_tamanofotos', 'n', Infinity);
        __updateContactPosition.call(this);
    };

    var __toGalleryP = function () {
        resetHeightGallery();
        this.__$flexImages.addClass('p').removeClass('n').removeClass('g').removeClass('flex-images-g');
        this.__$gallerySizeP.addClass('active');
        this.__$gallerySizeN.removeClass('active');
        this.__$gallerySizeG.removeClass('active');
        this.__$imageItem.removeAttr('style');
        this.__$allPicsBtm.removeClass('u-hide-none');
        this.__$morePicsBtn.addClass('u-hide-none');
        jquery('.fotos-responsive').removeClass('fotos-g').removeClass('fotos-n');
        this.__$flexImages.children('.n').css('height', (jquery('.ficha_foto.n').width() * 600) / 800);
        cookieService.setCookie('ad_tamanofotos', 'p', Infinity);
        this.__$flexImages.flexImages({ rowHeight: 600, truncate: 0, miniatures: true, big: false });
        this.__$flexImages.children('.p').removeAttr('style');
        __updateContactPosition.call(this);
    };

    var __toGalleryG = function () {
        this.__$flexImages.flexImages({ big: true });
        this.__$flexImages.removeClass('p').removeClass('n').addClass('g').addClass('flex-images-g');
        this.__$imageItem.addClass('g').removeClass('n').removeClass('p');
        this.__$gallerySizeG.addClass('active');
        this.__$gallerySizeN.removeClass('active');
        this.__$gallerySizeP.removeClass('active');
        this.__$allPicsBtm.addClass('u-hide-none');
        this.__$morePicsBtn.addClass('u-hide-none');
        this.__$imageItem.removeAttr('style');
        this.__$flexImages.children('image').attr('src', function () {
            var src = jquery(this).attr('src');
            if (src.indexOf('G.jpg') === -1) {
                src = src.replace(/P.jpg/i, '.jpg');
                src = src.replace(/.jpg/i, 'G.jpg');
            }
            return src;
        });
        cookieService.setCookie('ad_tamanofotos', 'g', Infinity);
        checkHeightGallery.call(this);
        __updateContactPosition.call(this);
    };

    var checkHeightGallery = function () {
        var viewportHeight = $(window).height() - 56;
        for (var i = 0; i < this.__$imageItem.length; i++) {
            var itemHeight = jquery(this.__$imageItem[i]).height();
            if (itemHeight > viewportHeight) {
                jquery(this.__$imageItem[i]).addClass('max-viewport');
            }
        }
    };

    var resetHeightGallery = function () {
        jquery('.max-viewport').removeClass('.max-viewport');
    };

    var __counterofferCheck = function () {
        var nPrize = parseInt(jquery('#js-counteroffer-offer').val().replace(' ', '').replace('?', '').replace('.', '').replace('.', ''));
        var sPrize;
        var $offerError = jquery('#js-counteroffer-error');
        var $offerError2 = jquery('#js-counteroffer-error-down');

        $offerError.addClass("hide-none");
        $offerError2.addClass("hide-none");

        if (!isNaN(nPrize)) {
            sPrize = Functions.FormatNumber(nPrize, 0, 3, '.');
            jquery('#js-counteroffer-offer').val(sPrize);
        } else {
            nPrize = 0;
        }
        if (nPrize > 0) {
            if ((nPrize < (this.__fichaDesktopDTO.precioProducto - (this.__fichaDesktopDTO.precioProducto * 0.75))) && (nPrize < this.__fichaDesktopDTO.precioProducto)) {
                $offerError2.removeClass('hide-none');
            } else {
                if (nPrize > this.__fichaDesktopDTO.precioProducto) {
                    $offerError.removeClass("hide-none");
                } else {
                    $offerError.addClass("hide-none");
                    $offerError2.addClass("hide-none");
                }
            }
            if ($offerError.hasClass("hide-none") && $offerError2.hasClass("hide-none")) {
                document.location.hash = "";
                jquery('#descripcion, #Mensaje').val(this.__fichaDesktopDTO.Translate.CounterofferIntro + jquery('#descripcion, #Mensaje').data('referencia') + this.__fichaDesktopDTO.Translate.CounterofferEnd + sPrize + "€.");
                jquery("#submit1, #submitSolicitudes").val(this.__fichaDesktopDTO.Translate.CounterofferBtn);
                document.location.hash = "solicitud";
            }
        }
    };

    var __getTopFormularioSolicitud = function () {
        return (this.__bHayFormularioSolicitud > 0 ? this._jqueryformularioSolicitud.offset().top : 0);
    };

    var __hasScrolled = function (scrollTop) {

        if (scrollTop > this.__lastScrollTop) {
            //down
            this._jquerybackToTop.removeClass('back-top-visible');
            if (scrollTop > this.__posicionIniFicha + 200) { this._jqueryheader.addClass('head-main-hide'); }
            this.__$headSecond.addClass('head-second-visible');
            this._jquerycontactarSuperior2.addClass('contact-top-fixed-up');
        } else {
            //up
            if (Math.abs(this.__lastScrollTop - scrollTop) <= this.__minScroll) {
                return;
            } else {
                this._jquerybackToTop.addClass('back-top-visible');
                if (scrollTop > this.__posicionIniFicha + 200) { this._jqueryheader.removeClass('head-main-hide'); }
                this._jqueryheader.addClass('bg-orange');
                this.__$headMain.addClass('bg-orange');
                this._jquerycontactarSuperior2.removeClass('contact-top-fixed-up');
            }
        }

        this.__lastScrollTop = scrollTop;
    };

    var __showTraduccionNoAvaible = function () {
        this._jqueryTxtNoTranslate.show();
        this._jquerytxtTraducido.hide();
        this._jquerylnkTraducir.hide();
    };

    var __showTraduccion = function (destacado, observaciones) {

        var traducido = false;

        if (destacado) {
            this.__destacadoTraducido = destacado;
            this._jquerydestacado.text(destacado);
            traducido = true;
        }

        if (observaciones) {
            this.__observacionesTraducidas = observaciones;
            this._jqueryobservaciones.text(observaciones);
            traducido = true;
        }

        if (traducido) {
            this._jquerytxtTraducido.show();
            this._jquerylnkTraducir.hide();
        }
    };

    var __launchFichaLoaded = function () {
        jquery.publish(HabEvents.EventsEnum.FichaLoaded);
    };

    var __setDescartado = function () {
        if (jquery('#js-discard').length > 0) {
            if (this.__fichaDesktopDTO.EsDescartado === 'True') {
                __changeToDescartado.call(this);
                this._jquerycontenidoFicha.addClass('is-discarted');
            }
            this._jqueryidDescartarAnuncio = jquery('#js-discard-btn');
            this._jqueryidConfirmacionDescartadoDiv = jquery('#js-discard-confirmation');
            __registerEventsDescartado.call(this);
        }
    };

    var __changeToDescartado = function () {
        var self = this;
        var confirmacionTemplate = document.getElementById('{{discard-confirmation-template}}').cloneNode(true);
        confirmacionTemplate.id = 'js-discard-confirmation';

        var descartarDiv = document.getElementById('js-discard');
        descartarDiv.appendChild(confirmacionTemplate);
        self._jquerycontenidoFicha.addClass('is-discarted');
        jquery('.discard-recover-btn').click(function () {
            descartarInmueble.RecuperarDescartado();
          __changeToRecuperado.call(self);
          jquery.publish(HabEvents.EventsEnum.AdRecovered, self.__fichaDesktopDTO.codigoAnuncio);
        });
        Functions.ExpandElement(jquery('#js-discard-confirmation'), jquery('#js-discard-confirmation>span'));
    };

    var __changeToRecuperado = function () {
        this._jquerycontenidoFicha.removeClass('is-discarted');
        Functions.ReduceElement(jquery('#js-discard-confirmation'), 0);
        setTimeout(function () { jquery('#js-discard-confirmation').remove(); }, 200);
    };

    var __registerEventsDescartado = function () {
        var self = this;
        jquery.subscribe(HabEvents.EventsEnum.InmuebleDescartado, function () {
            self._jquerycontenidoFicha.addClass('is-discarted');
            Functions.ExpandElement(self._jqueryidConfirmacionDescartadoDiv, jquery('#js-discard-confirmation>span'));
        });
        jquery.subscribe(HabEvents.EventsEnum.InmuebleDescartadoRecuperado, function () {
            self._jquerycontenidoFicha.removeClass('is-discarted');
            Functions.ReduceElement(self._jqueryidConfirmacionDescartadoDiv, 0);
        });
        jquery('#js-discard-btn').unbind().click(function () {
            if (self.__fichaDesktopDTO.idUsuario > 0) {
                if (jquery('#js-discard-confirmation').length <= 0) {
                    descartarInmueble.DescartarInmueble();
                  __changeToDescartado.call(self);
                  jquery.publish(HabEvents.EventsEnum.AdDiscarded, self.__fichaDesktopDTO.codigoAnuncio);
                }
            } else {
                AccountUser.ShowModalLogin();
            }
        });

    };

    var __focusInSolicitud = function () {
        this.__$reportErrorBottom.addClass('hide');
        this.__$navFixed.addClass('hide');
        this._jquerybackToTop.addClass('hide-none');
        this.__$navBottomBack.addClass('hide');
        this.__$navDetail.addClass('hide');
        this.__$navKeyboard.addClass('hide');
    };
    var __focusOutSolicitud = function () {
        this.__$reportErrorBottom.removeClass('hide');
        this.__$navFixed.removeClass('hide');
        this._jquerybackToTop.removeClass('hide-none');
        this.__$navBottomBack.removeClass('hide');
        this.__$navDetail.removeClass('hide');
        this.__$navKeyboard.removeClass('hide');
    };

    var __unbranded = function () {
        if (window.self !== window.top) {
            var anchors = document.querySelectorAll('[target="_blank"]');
            if (!!anchors.length && anchors.length > 0) {
                for (var i = 0; i < anchors.length; i++) {
                    anchors[i].target = '_self';
                }
            }

        }
    };
    var __visitadosCookieManager = function () {
        var valor = "";

        valor = decodeURIComponent(cookieService.getCookie(this._COOKIENAME));

        if (valor !== "" && !!valor && valor !== 'null') {
            var splited = valor.split(",");
            var longitud = splited.length;
            for (var i = 0; i < longitud; i++) {
                this.__inmueblesVisitados.push(splited[i]);
            }
        }
    };

    var __addInmuebleVisitado = function () {
        var self = this;

        __tcfapi && __tcfapi('getTCData',2, data => {
            if (data.purpose.consents[5] && data.purpose.consents[6] && data.purpose.consents[10]){
                if (!HabUtils.ExistStringInArray(self.__fichaDesktopDTO.codigoAnuncio, self.__inmueblesVisitados)) {
                    self.__inmueblesVisitados.push(self.__fichaDesktopDTO.codigoAnuncio);
                    var valor = self.__inmueblesVisitados.join();
                    cookieService.setCookie(self._COOKIENAME, valor, 10000);
                }
            }
        });
    };

    var __alertInDetail = function () {
        if(!window.matchMedia('(max-width: 1196px)').matches && typeof(window.URL)==="function"){
            var url = new URL(window.location.href);
            var idEnvio = url.searchParams.get('idenvio');
            if(idEnvio){
                __getAlertList.call(this, idEnvio);
            }else{
                jquery('#js-filters').addClass('filter-visible');
            }
        }else{
            jquery('#js-filters').addClass('filter-visible');
        }
    };

    var __getAlertList = function (id) {
        var self = this;
        var urlGetJson = this.__fichaDesktopDTO.urlGetAlert + id;
        jquery.ajax({
            type: "GET",
            url: urlGetJson,
            dataType: "json",
            statusCode: {
                200: function (response) {
                    if (!!response.responseText) {
                        __appendAlertList.call(self, response.responseText, id);
                    }
                },
                404: function (){
                    jquery('#js-filters').addClass('filter-visible');
                }
            }
        });
    };

    var __appendAlertList = function (data, id){
        var parsedData = jquery.parseHTML(data);
        var $data = jquery(parsedData).find('#lista');
        $data.addClass('detail-alert');
        $data.id = 'js-detail-alert';
        var $noData = $data.find('.alertaSinDatos');
        if($data.length>0 && $noData.length === 0){
            $data.find('.header-list-alerts').remove();
            $data.prepend('<li>'+this.__fichaDesktopDTO.Translate.AlertTitle+' ;)</li>');
            var $anchors = $data.find('a');
            Array.prototype.slice.call($anchors).forEach((anchor) => {
                anchor.href = anchor.href + '?lo=73&idenvio=' + id;
            });
            var $filterContainer = jquery('.filter-detail');
            $filterContainer.append($data);
            setTimeout(()=>{$filterContainer.addClass('detail-alert-container');}, 100);
            $filterContainer.click(()=>{
                jquery.publish(HabEvents.EventsEnum.NavegacionFicha, ['ficha-nav-link', 'alert-in-detail']);
            });
          }else{
            jquery('#js-filters').addClass('filter-visible');
        }
    };

    FichaDesktopIndex.prototype = {
        constructor: FichaDesktopIndex
    };

    if (typeof module !== 'undefined' && module.exports) {
        /*jshint undef: false*/
        module.exports = new FichaDesktopIndex(FichaDesktopDTO, WideMediaDTO, WideMediaPromoDTO, LiveNotificationDTO, MortgageLeadDTO);
    } else {
        window.FichaDesktopIndex = FichaDesktopIndex;
    }
}());
